import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { UnitCode } from '@ordersnproducts/modules/one-click-order/util/enums/one-click-unit.enum';
import { tonUnitConverter } from '@ordersnproducts/modules/shared/utils/api-data-correction';

export class OneClickStandardLotProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getOneClickSelectedOrder).pipe(
      filter(order => !!order && !!order.items && !!order.items.length),
      map(order => order.items[0]),
      map(item => {
        return `${item.quantity} ${tonUnitConverter(item.uom.unitCode) || UnitCode.Ton}`;
      }),
    );
  }
}
